import { toggleSpinner, updateMessages, toggleCloudFlareModal } from 'actions/appAction';

import { AUTH_INCOMPLETE_PAYMENT_INFO, AUTH_REQUEST_CANCEL_LINK } from 'constants/UrlConstants';

import { apiFetchData } from 'helpers/api';

import { addExtras, setExtra, updateExtraByName } from './extraAction';
import { setNewForm } from './formAction';
import { UPDATE_PAGE_MESSAGES } from './messageAction';
import { INCOMPLETE_TRANSFER, USER_COUNTRY } from '../constants/ExtraNames';

export const RENAME_PAYMENT = 'RENAME_PAYMENT';
export const ADD_NEXT_BILLS = 'ADD_NEXT_BILLS';
export const UPDATE_RECORDS = 'UPDATE_RECORDS';
export const GET_CHEQUE = 'GET_CHEQUE';
export const GET_REQUEST_CHEQUE = 'GET_REQUEST_CHEQUE';
export const ADD_NEXT_PAYMENTS = 'ADD_NEXT_PAYMENTS';
export const UPDATE_REQUEST_BY_FILTER = 'UPDATE_REQUEST_BY_FILTER';
export const SET_HISTORY = 'SET_HISTORY';

export const setHistory = (extra) => {
    return (dispatch) => {
        return Promise.resolve(dispatch({ type: SET_HISTORY, extra: extra }));
    };
};
export const closeRequest = (billId) => {
    return (dispatch) => {
        dispatch(toggleSpinner(true));
        return Promise.resolve(
            apiFetchData(`${AUTH_REQUEST_CANCEL_LINK}?billId=${billId}`)
                .then((json) => {
                    dispatch(updateMessages(json.messageBodyMessages));
                    dispatch(updateRequestByFilter(json?.extra?.billHistory));
                })
                .finally(() => {
                    dispatch(toggleSpinner(false));
                }),
        );
    };
};
export const dismissIncompletePayment = () => {
    return (dispatch) => {
        dispatch(toggleSpinner(true));
        return Promise.resolve(
            apiFetchData(`/auth/payments/history/incomplete-payment/remove.action`)
                .then((json) => {
                    dispatch(updateMessages(json.messageBodyMessages));
                    dispatch(updateRequestByFilter(json?.extra?.paymentHistory));
                    dispatch(setExtra(json?.extra));
                })
                .finally(() => {
                    dispatch(toggleSpinner(false));
                }),
        );
    };
};
const updateRequestByFilter = (paymentHistory) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_REQUEST_BY_FILTER,
                paymentHistory: paymentHistory,
            }),
        );
    };
};
export const getCheque = (paymentId) => {
    return (dispatch) => {
        dispatch(toggleSpinner(true));
        const dispatchToggleCloudFlareModal = (isShow, path, options) => dispatch(toggleCloudFlareModal(isShow, path, options));
        return Promise.resolve(
            apiFetchData(`/auth/cheque/${paymentId}`, null, null, { toggleCloudFlareModal: dispatchToggleCloudFlareModal })
                .then((json) => {
                    dispatchChequeFromJson(dispatch, json);
                })
                .finally(() => {
                    dispatch(toggleSpinner(false));
                }),
        );
    };
};
export const getIncompletePaymentCheque = () => {
    return (dispatch) => {
        dispatch(toggleSpinner(true));
        const dispatchToggleCloudFlareModal = (isShow, path, options) => dispatch(toggleCloudFlareModal(isShow, path, options));
        return Promise.resolve(
            apiFetchData(AUTH_INCOMPLETE_PAYMENT_INFO, null, null, { toggleCloudFlareModal: dispatchToggleCloudFlareModal })
                .then((json) => {
                    dispatch(updateExtraByName(USER_COUNTRY, json.extra?.userCountry));
                    dispatch(updateExtraByName(INCOMPLETE_TRANSFER, json.extra?.incompleteTransfer));
                    dispatchIncompletePaymentCheque(dispatch, json);
                })
                .finally(() => {
                    dispatch(toggleSpinner(false));
                }),
        );
    };
};
export const setCheque = (cheque, isIncompleteTransfer = false) => {
    return (dispatch) => {
        return isIncompleteTransfer ? Promise.resolve(dispatchIncompletePaymentCheque(dispatch, cheque)) : Promise.resolve(dispatchCheque(dispatch, cheque));
    };
};
export const dispatchChequeFromJson = (dispatch, json = {}) => {
    if (json?.messages) {
        dispatch({
            type: UPDATE_PAGE_MESSAGES,
            pageMessages: json.messages,
        });
    }
    if (json?.forms) {
        Object.values(json.forms).forEach((form) => {
            dispatch(setNewForm(form?.name, form?.fields, form?.action));
        });
    }
    if (json?.extra) {
        dispatch(addExtras(json?.extra));
    }
    return dispatch({
        type: GET_CHEQUE,
        cheque: json?.extra?.cheque,
    });
};

export const dispatchCheque = (dispatch, cheque) => {
    return dispatch({
        type: GET_CHEQUE,
        cheque: cheque,
    });
};
export const dispatchIncompletePaymentCheque = (dispatch, json = {}) => {
    if (json?.messages) {
        dispatch({
            type: UPDATE_PAGE_MESSAGES,
            pageMessages: json.messages,
        });
    }
    return dispatch({
        type: GET_CHEQUE,
        cheque: json?.extra?.incompletePayment,
    });
};
export const getRequestCheque = (requestId, setSeen = true) => {
    return (dispatch) => {
        dispatch(toggleSpinner(true));
        return Promise.resolve(
            apiFetchData(`/auth/request/cheque/${requestId}?history=true&setSeen=${setSeen}`)
                .then((json) => {
                    dispatch({
                        type: GET_REQUEST_CHEQUE,
                        cheque: json,
                    });
                })
                .finally(() => {
                    dispatch(toggleSpinner(false));
                }),
        );
    };
};
export const addNextPayments = (payments) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: ADD_NEXT_PAYMENTS,
                paymentHistory: payments,
            }),
        );
    };
};
export const addNextBills = (billHistory) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: ADD_NEXT_BILLS,
                billHistory: billHistory,
            }),
        );
    };
};
export const renamePayment = (paymentId, name = '') => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: RENAME_PAYMENT,
                paymentId: paymentId,
                name: name,
            }),
        );
    };
};

export const updateRecords = (paymentId, status, paymentIndex, recordIndex, newRecord) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_RECORDS,
                paymentId,
                status,
                paymentIndex,
                recordIndex,
                newRecord,
            }),
        );
    };
};
